<template>
	<div class="order">
		<v-contextual-content ref="contextual" :class="orderClass" class="v-contextual--order">
			<template v-slot:trigger="{ toggle }">
				<button
					title="Products" @click="toggle">Order Summary
				</button>
			</template>
			<template v-slot:default="{ toggle }">
				<header>
					<h1 class="beta heavy">Cart</h1>
				</header>
				<div class="v-contextual--order__summary">
					<template v-if="!cartHasItems">
						<div class="nothing-to-see-here">
							<p>Your cart is empty.</p>
						</div>
						<ul class="actions">
							<li class="wide">
								<button
									v-if="$route.name !== 'products.index'"
									class="button button--primary--wide" @click.prevent="goToProducts()">
									<span>Buy Products</span></button>
								<button
									v-else
									class="button button--primary--wide" @click.prevent="toggle()">
									<span>Buy Products</span></button>
							</li>
						</ul>
					</template>
					<template v-else>
						<dl>
							<dt>Products</dt>
							<dd
								class="beta"
								v-html="$present('ntext', '# Product', '# Products', numberOfCartItems)"/>
						</dl>
						<ul class="actions">
							<li class="wide">
								<router-link
									:to="{name: 'cart'}"
									class="button button--primary">Complete Order</router-link>
							</li>
						</ul>
					</template>
				</div>
			</template>
		</v-contextual-content>
	</div>
</template>
<script>
import {mapGetters} from "vuex";

export default {
	computed: {
		...mapGetters("cart", ["cartHasItems", "numberOfCartItems"]),
		orderClass() {
			return {
				"v-contextual--order--has-items": this.cartHasItems,
			};
		},
	},

	methods: {
		goToProducts() {
			this.$router.push({name: "products.index"});
			this.refs.contextual.toggle();
		},
	},
};
</script>
